export default "__VITE_ASSET__BcauQJcc__"